// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3vgg5","total":"style_total__2r14w"};